import { render, staticRenderFns } from "./ArchiveScopeList.vue?vue&type=template&id=6778b2de&"
import script from "./ArchiveScopeList.vue?vue&type=script&lang=js&"
export * from "./ArchiveScopeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports